import {
  postRequest,
  putRequest,
  getRequest,
  deleteRequest,
} from 'helpers/axios';
const BASE_URL = '';

const createBusiness = (body) => {
  return postRequest(`businesses`, body);
};

const getScrappedBusiness = (url) => {
  return getRequest(`businesses/scraped_summary?url=${url}`);
};

const getBusinessById = (id) => {
  return getRequest(`businesses/${id}`);
};

const updateBusinessById = (id, body) => {
  return putRequest(`businesses/${id}`, body);
};

const getAnalyzeBusiness = (url, populateBrandIntelligence = false, forceRefresh = false, businessId = null) => {
  return postRequest(`scripts/analyze`, {
    url,
    populate_brand_intelligence: populateBrandIntelligence,
    force_refresh: forceRefresh,
    business_id: businessId,
  });
};

export const getLicenseData = () => {
  return getRequest(`app_sumo/app_sumo_license`);
};

const getContentTopics = (body) => {
  return postRequest(
    `businesses/generate_content_topics_for_user_entered_summary`,
    body,
  );
};

const postFailedScrapper = (url) => {
  return postRequest(`scripts/handle_failed_scraper`, { url });
};

const getUserBrandInfo = () => {
  return getRequest(`user_brands_info`);
};

const deleteBrand = (id) => {
  return deleteRequest(`businesses/${id}`);
};

// Brand Intelligence APIs
const createBrandProfile = (data) => {
  return postRequest(`brand_intelligence/profiles`, data);
};

const getBrandProfile = (brandProfileId) => {
  return getRequest(`brand_intelligence/profiles/${brandProfileId}`);
};

const updateBrandProfile = (brandProfileId, data) => {
  return putRequest(`brand_intelligence/profiles/${brandProfileId}`, data);
};

const uploadContentSample = (brandProfileId, formData) => {
  // FormData Content-Type is auto-detected by axios with proper boundary
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/content_samples`,
    formData
  );
};

const listContentSamples = (brandProfileId, limit = 500) => {
  return getRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/content_samples?limit=${limit}`
  );
};

const deleteContentSample = (brandProfileId, sampleId) => {
  return deleteRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/content_samples/${sampleId}`
  );
};

// Document Import APIs - import published documents as content samples
const previewDocumentImport = (brandProfileId) => {
  return getRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/import_documents/preview`
  );
};

const importDocuments = (brandProfileId) => {
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/import_documents`
  );
};

// Blog Discovery & Import APIs
const discoverBlogs = (brandProfileId, websiteUrl, maxPosts = 30) => {
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/discover_blogs`,
    { website_url: websiteUrl, max_posts: maxPosts }
  );
};

const importBlogs = (brandProfileId, urls) => {
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/import_blogs`,
    { urls }
  );
};

const autoImportBlogs = (brandProfileId, websiteUrl, maxPosts = 20) => {
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/auto_import_blogs`,
    { website_url: websiteUrl, max_posts: maxPosts }
  );
};

const getBlogPosts = (brandProfileId, limit = 50) => {
  return getRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/blog_posts?limit=${limit}`
  );
};

// Quick Start file analysis - extracts content and runs brand analysis
const analyzeFiles = (brandProfileId, files) => {
  const formData = new FormData();
  files.forEach((fileObj) => {
    // Handle both {file: File} objects and raw File objects
    const file = fileObj.file || fileObj;
    formData.append('files[]', file);
  });
  // FormData Content-Type is auto-detected by axios with proper boundary
  return postRequest(
    `brand_profiles/${brandProfileId}/brand_intelligence/analyze_files`,
    formData
  );
};

const onBoardingService = {
  createBusiness,
  getScrappedBusiness,
  getAnalyzeBusiness,
  postFailedScrapper,
  getContentTopics,
  getBusinessById,
  updateBusinessById,
  getUserBrandInfo,
  deleteBrand,
  getLicenseData,
  // Brand Intelligence
  createBrandProfile,
  getBrandProfile,
  updateBrandProfile,
  uploadContentSample,
  listContentSamples,
  deleteContentSample,
  // Document Import
  previewDocumentImport,
  importDocuments,
  // Blog Discovery & Import
  discoverBlogs,
  importBlogs,
  autoImportBlogs,
  getBlogPosts,
  // Quick Start file analysis
  analyzeFiles,
};

export default onBoardingService;
